import React from 'react';
import ListarEquipos from '../../../components/insumos/equipos/ListarEquipos';

const EquiposPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarEquipos />
    </div>
  );
};

export default EquiposPage;